import { OrgInviteTable } from "../components/OrgInvite/OrgInviteTable";
import { OrgInviteActions } from "../components/OrgInvite/OrgInviteActions";
import { OrgInviteBulkInput } from "../components/OrgInvite/OrgInviteBulk";
import { OrgView } from "../components/Org";
import { useOrgParams, usePermissions } from "../hooks";
import { UnauthorizedMessage } from "../../shared/components";
import { H2 } from "@datapay-by-datacom/design-system";
import styles from "./OrgInvitesScreen.module.css";

export function OrgInvitesScreen() {
  const { id } = useOrgParams();
  const { isAdminOfOrg } = usePermissions();

  // Only admins can access this page
  if (!isAdminOfOrg(id)) {
    return <UnauthorizedMessage />;
  }

  return (
    <OrgView title="Invitations">
      {({ category, id }) => (
        <>
          <OrgInviteActions category={category} id={id} />
          <OrgInviteTable category={category} id={id} />

          <div className={styles.bulkInviteSection}>
            <H2 className={styles.bulkInviteTitle}>Bulk Invite</H2>
            <OrgInviteBulkInput />
          </div>
        </>
      )}
    </OrgView>
  );
}
